import React, { useMemo } from 'react';
import "./BakeryCircleItemStyles.scss"
import ChekMark from "../../img/chek_mark.svg"
import {HandySvg} from "handy-svg";
import { getTaskColors, formatTime, getDisplayName } from "./lib/BakeryCircleItemUtils";

const BakeryCircleItem = ({ data }) => {

    const { progress, backgroundColor, svgColor } = useMemo(() =>
            getTaskColors(data),
        [data?.time_start, data?.time_end]
    );

    return (
        <div className="bakery_scroll-item" style={{ backgroundColor }}>
            <HandySvg className="check-mark" src={ChekMark} style={{ color: svgColor }} />
            <div className="bakery_scroll-item__name">{getDisplayName(data)}</div>
            <div className="bakery_scroll-item__time">
                {formatTime(data?.time_start)}-{formatTime(data?.time_end)}
            </div>
        </div>
    );
};

export default BakeryCircleItem;